import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";

const Select = styled.select`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  margin-left: 10px;
  padding: 0 16px;
`;

const Button = styled.button`
  margin-left: 2%;
  type: button;
  class: btn btn-custom-color btn-hover-shine me-3 btn;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PharmacyLadgerDetailsFilter = ({ onClear, onSearch, filterStatus }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(filterStatus || "");

  const handleClear = () => {
    onClear();
    setStatus('');
  };

  const handleSearch = () => {
    onSearch(status);
  };

  return (
    <Container>
      <Select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">{t('Select Status')}</option>
        <option value="+">{t('Credit')}</option>
        <option value="-">{t('Debit')}</option>
      </Select>

      <Button className="btn btn-custom-color btn-hover-shine me-3 btn"
        onClick={handleSearch}
      >
        {t('Search')}
      </Button>
      <Button className="btn btn-custom-color btn-hover-shine me-3 btn"
        onClick={handleClear}
      >
        {t('Reset')}
      </Button>
    </Container>
  );
};

export default PharmacyLadgerDetailsFilter;
